__turbopack_context__.v({
  "title": "PerformersList-module-scss-module__3vrc5G__title",
  "visuallyHidden": "PerformersList-module-scss-module__3vrc5G__visuallyHidden",
});
